import { render, staticRenderFns } from "./cxdate.vue?vue&type=template&id=509b1aef&scoped=true&"
import script from "./cxdate.vue?vue&type=script&lang=js&"
export * from "./cxdate.vue?vue&type=script&lang=js&"
import style0 from "./cxdate.vue?vue&type=style&index=0&id=509b1aef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b1aef",
  null
  
)

export default component.exports